import { View, Text } from 'react-native'
import { PrescriptionResponse } from '@ca/common'
import {
  backgroundColorViewField,
  sViewFieldContainer,
} from '@screens/vision/prescription/form/styles'
import cn from '@ui/utils/cn'
import Typography from '@ui/typography'

interface Props {
  data: PrescriptionResponse
}

export default function Comment(props: Props) {
  const { remark } = props.data

  return (
    <View style={{ padding: 32, paddingLeft: 128 }}>
      <View
        className={cn(
          sViewFieldContainer,
          'items-start justify-start px-6 py-4'
        )}
        style={{ minHeight: 160, backgroundColor: backgroundColorViewField }}
      >
        <Typography variant="SM" className="font-text-semibold">
          {remark}
        </Typography>
      </View>
    </View>
  )
}
